<div [formGroup]="inputNumericFormControl">
  <mat-form-field class="inputs">
    <input matInput formControlName="importe"
           (blur)="formatear()"
           [placeholder]="placeHolderValue" [attr.disabled]="DeshabilitarControl ? 'disabled' : null" appDecimalDigitos>
    <mat-error *ngIf="inputNumericFormControl.controls.importe?.errors?.required || inputNumericFormControl.hasError('numeroInvalido')">
      Valor inválido
    </mat-error>
  </mat-form-field>
</div>

